module.exports = __webpack_public_path__ + "img/jcb.107d9a29.png";